// extracted by mini-css-extract-plugin
export default {"button":"style_button__krlqK","primary":"style_primary__P-A1W","secondary":"style_secondary__dxQ-T","icon":"style_icon__yDdxs"};